"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IcnsFileHeader = /** @class */ (function () {
    function IcnsFileHeader(identifier, bytes) {
        if (identifier === void 0) { identifier = 'icns'; }
        if (bytes === void 0) { bytes = 8; }
        this.identifier = identifier;
        this.bytes = bytes;
    }
    /**
     * Create ICNS file header from the buffer.
     * @param buffer The ICNS file header buffer.
     */
    IcnsFileHeader.from = function (buffer) {
        var identifier = buffer.toString('ascii', 0, 4);
        var bytes = buffer.readUInt32BE(4);
        return new IcnsFileHeader(identifier, bytes);
    };
    Object.defineProperty(IcnsFileHeader.prototype, "data", {
        get: function () {
            var buffer = Buffer.alloc(8);
            buffer.write(this.identifier, 0, 4, 'ascii');
            buffer.writeUInt32BE(this.bytes, 4);
            return buffer;
        },
        enumerable: true,
        configurable: true
    });
    return IcnsFileHeader;
}());
exports.IcnsFileHeader = IcnsFileHeader;
